import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68463f8b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sponsorlist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 centertext" }, "Sponsorer", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "sponsorcontainer"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_divider = _resolveComponent("va-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_va_divider),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sponsors, (sponsor, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "sponsorcard"
            }, [
              _createElementVNode("a", {
                href: sponsor.sponsor_link,
                target: "_blank",
                rel: "noopener"
              }, [
                _createElementVNode("img", {
                  src: _ctx.APIURL + sponsor.sponsor_billede.url,
                  alt: sponsor.sponsor_sponsornavn + ' Logo',
                  width: "250"
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5)
            ]))
          }), 128))
        ]))
  ]))
}